import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ClientProfileModal from '../components/ClientProfileModal';

function ClientProfilePage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/clients'); // Navigate back to the clients list on close
  };

  return (
    <ClientProfileModal
      open={true}
      onClose={handleClose}
      clientId={id}
    />
  );
}

export default ClientProfilePage;